import './Stakeholder.scss'
import { useState } from 'react'
import { useTranslation } from "react-i18next"
import { Button, Icon, Form, Row, Col, Input, notification, Select } from 'antd'
import { getUserPromise, forgotUserPromise } from './promises'
import { Captcha } from '../../layouts/Private/components'
import { validateEntityRutHelper } from "../../helpers";
import { LocalStorageService } from '../../services'
import i18n from '../../config/i18next'

const StakePublic = ({ form, match, client, successHandler }) => {
	const { t } = useTranslation();
	const { getFieldDecorator } = form
	const [isCreate, setIsCreate] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [isRestore, setIsRestore] = useState(false)
	const [rut, setRut] = useState(null)
	const [password, setPassword] = useState(null)
	const [captchaResponse, setCaptchaResponse] = useState(null);
	const [captchaSucess, setCaptchaSuccess] = useState(false);
	const [captchaKey, setCaptchaKey] = useState(Math.random());
	const isLoginView = !isRestore && !isCreate;

	const renderFormItem = (formItem) => {
		return (
			<Row className = {formItem.styleClass}>
				<Form.Item label={ formItem.label }>
					{ getFieldDecorator(formItem.name, { rules: formItem.rules, initialValue: formItem.initialValue })(formItem.item) }
				</Form.Item>
			</Row>
		)
	}

	const handleSubmit = async (e) => {
		handleCatpcha(false)
		setCaptchaKey(Math.random());
		e.preventDefault()
		setIsLoading(true)

		const language = i18n.language
		if(isRestore) {
			/*
			if(!captchaResponse) {
				notification.error({
					placement: 'topLeft',
					message: "Error",
					description: "Validacion no Superada"
				})
				setIsLoading(false)
				return;
			}*/

			const u = await forgotUserPromise(client.id, rut, captchaResponse, language.substring(0, 2))
			if (u.data.status === 'OK') {
				if(u.data.code === '401') {
					handleErrors(u.data.code, "Error", true);
				} else if(u.data.code === '409') {
					handleErrors(u.data.code, "Error", true);
				} else if(u.data.code === '400-10') {
					handleErrors(u.data.code, "Aviso", true);
				} else if(u.data.code === '400-20') {
					handleErrors(u.data.code, "Aviso", true, u.data.attemps);
				} else if(u.data.code === '202') {
					handleErrors(u.data.code, t("messages.aml.successfulOperation"), false, u.data.attemps);
				} else if(u.data.code === '200') {
					setIsRestore(false)
				} else {
					handleErrors(u.data.code, "Error", true);
				}
	    	}
		}else if(isCreate) {
			/*
			if(!captchaResponse) {
				notification.error({
					placement: 'topLeft',
					message: "Error",
					description: "Validacion no Superada"
				})
				setIsLoading(false)
				return;
			}*/

			if(client.country === 'CHI' && !validateEntityRutHelper(rut)){
				notification.error({
					placement: 'topLeft',
					message: "Error",
					description: "Rut no es válido"
				})
				setIsLoading(false);
				return;
			}

			const u = await forgotUserPromise(client.id, rut, captchaResponse, language.substring(0, 2))
			if (u.data.status === 'OK') {
				if(u.data.code === '401') {
					handleErrors(u.data.code, "Error", true);
				} else if(u.data.code === '409') {
					handleErrors(u.data.code, "Error", true);
				} else if(u.data.code === '400-10') {
					handleErrors(u.data.code, "Aviso", true);
				} else if(u.data.code === '400-20') {
					handleErrors(u.data.code, "Aviso", true, u.data.attemps);
				} else if(u.data.code === '202') {
					handleErrors(u.data.code, t("messages.aml.successfulOperation"), false, u.data.attemps);
				} else {
					handleErrors(u.data.code, "Error", true);
				}
	    	}
		} else {
			const u = await getUserPromise(client.id, rut, password)
			if (u.data.status === 'OK') {
				if(u.data.code === '401') {
					handleErrors(u.data.code, "Error", true, u.data.attemps);
				} else if(u.data.code === '409') {
					handleErrors(u.data.code, "Error", true);
				} else if(u.data.code === '400-10') {
					handleErrors(u.data.code, "Aviso", true);
				} else if(u.data.code === '202') {
					await successHandler(u.data, u.data.code)
				} else if(u.data.code === '200') {
					await successHandler(u.data, u.data.code)
				} else {
					handleErrors(u.data.code, "Error", true);
				}
			}
		}
		setIsLoading(false)
  }

	const handleUsernameOnChange = (rut) => {
		setRut(rut);
	}

	const handlePasswordOnChange = (password) => {
		setPassword(password)
	}

	const handleSwitchToRestore = async (e) => {
		e.preventDefault()
		setIsRestore(true)
		handleCatpcha(false)
	}

	const handleSwitchToCreate = async (e) => {
		e.preventDefault()
		setIsCreate(true)
		handleCatpcha(false)
	}

	const handleSwitchToLogin = async (e) => {
		e.preventDefault()
		setIsRestore(false)
		setIsCreate(false)
		handleCatpcha(false)
	}

	const handleCatpcha = async (success, response) => {
		setCaptchaSuccess(success);
		if(response){
			setCaptchaResponse(response);
		}else{
			setCaptchaResponse(null);
			setCaptchaSuccess(false);
		}
	}


	const handleErrors = (errorCode, title, isError, attemps = null) => {
		let errorMsg = "Ocurrio un Error";
		switch(errorCode){
			case "202":
				if(attemps){
					errorMsg = t('portal.title.notification1', {attemps, ns: 'forms'})
				}else{
					errorMsg = t('portal.title.notification2', {ns: 'forms'})
				}
				break;
			case "401":
				if(attemps){
					errorMsg = t('portal.title.notification3', {attemps, ns: 'forms'})
				}else{
					errorMsg = t('portal.title.notification4', {ns: 'forms'})
				}
				break;
			case "400-10":
				errorMsg = t('portal.title.notification5', {ns: 'forms'})
				break;
			case "409":
				errorMsg = t('portal.title.notification6', {ns: 'forms'});
				break;
		}

		if(isError){
			notification.error({
				placement: 'topLeft',
				message: title,
				description: errorMsg
			  })
		}else{
			notification.success({
				placement: 'topLeft',
				message: title,
				description: errorMsg
			  })
		}

		setIsCreate(false);
		setIsRestore(false);
	}

	return (

		<div className="stakeholder-public">
			<div className="login">
				<div className="login-content">
					<Row>
					{/* {!(isCreate || isRestore) &&

						<Col className="instructions-box" xs={4} sm={5} md={6} lg={7} xl={7} push={15}>
							<>
							<h3>
								Instrucciones
							</h3>
							<p>
								Estimado usuario para ingresar al portal considere lo siguiente:
								<ul>
								<li> Si es persona natural debe ingresar el número de su documento de identidad seguido de su contraseña.</li>
								<li> Si es persona jurídica debe ingresar el número de documento de su empresa seguido de su contraseña.</li>
								</ul>
							</p>
							<p>
								En caso sea un <u>Nuevo Usuario</u> debe seguir los siguientes pasos:
								<ol>
									<li>Ingrese su número de documento (teniendo en cuenta si es persona natural o jurídica)</li>
									<li>Presione <strong>Solicitar contraseña</strong></li>
									<li>Marque el captcha</li>
									<li>Presione <strong>Enviar</strong></li>
									<li>La contraseña será enviada al correo electrónico previamente registrado en la plataforma.</li>
									<li>Cuando eso suceda, ingrese su usuario y la contraseña enviada; seguidamente el sistema le solicitará definir una contraseña personalizada.</li>
								</ol>
							</p>
							</>
						</Col>
					} */}
						<Col xs={24} className="login-container">
								<Form onSubmit={ handleSubmit } className="login-form">
								<div className={isLoginView ? 'portal-auth-cards' : undefined}>
								<div className="login-box">
									<Row>
										<Col xs={ 24 }>
										{ isRestore ?
												<h2>{t('messages.aml.restorePassword')}</h2>
												:
												(isCreate ? <h2>{t('messages.aml.register')}</h2>
												:
												(
													<h2 className="title">
														<span>{t('messages.aml.sessionStart')} <br/> {t('messages.aml.usersPortal')}</span>
													</h2>
													)
												)
											}
										</Col>
									</Row>
									<Row>
										<Col xs={ 24 }>
											{
												renderFormItem({
													label: t('messages.aml.portal.username'),
													styleClass: "crud-label",
													name: 'rut',
													rules: [{ required: true, message: t('messages.aml.dontForgetUsername') }],
													item: (
														<Input
															autocomplete="off"
															onChange={ (e) => handleUsernameOnChange(e.target.value) }
															prefix={ <Icon type="user" style={{ color: 'rgba(0,0,0,.2)' }} /> }
															placeholder={ t('messages.aml.rutNumber') }
															/>
													)
												})
											}
											{isCreate &&
												<span className="portal-label-hint" style={{display: 'block', marginTop: -5, textAlign: 'left'}}>
													{t('messages.aml.portal.rutHint')}
												</span>
											}
										</Col>
									</Row>
									{ isLoginView &&
										<Row>
											<Col xs={ 24 }>
												{
													renderFormItem({
														label: t('messages.aml.password'),
														styleClass: "crud-label",
														name: 'password',
														rules: [{ required: true, message: t('messages.aml.dontForgetPassword') }],
														item: (
															<Input.Password
																onChange={ (e) => handlePasswordOnChange(e.target.value) }
																type="password"
																autocomplete="off"
																prefix={ <Icon type="lock" style={{ color: 'rgba(0,0,0,.2)' }} /> }
																placeholder={ t('messages.aml.password') }
																/>
														)
													})
												}
											</Col>
										</Row>
									}
									{/*(isRestore || isCreate) &&
										<Row className="captchaVerify" style={{paddingTop:'10px'}}>
											<Captcha success={handleCatpcha} key={captchaKey}/>
										</Row>
									*/}
									{ (true || captchaSucess || isLoginView) &&
									<Row>
										<Col xs={ 24 }>
											<Button className="login-form-button-portal" type="primary" htmlType="submit" disabled={rut === null || rut === undefined || rut === ''}>{ isLoginView ? t('messages.aml.sessionStart') : t('messages.aml.send') }</Button>
										</Col>
									</Row>
									}
									{ isRestore ?
										<Row className="login-description">
											<Col xs={ 24 }>
											{t('messages.aml.newPassword.will.send.to')}
											</Col>
										</Row>
										: isCreate ?
										<Row className="login-description">
											<Col xs={ 24 }>
												{t('messages.aml.password.will.send')}
											</Col>
										</Row>
										:
										<Row>
										</Row>
									}
									{isLoginView &&
										<Row className="forgot-container">
											<a href='#' onClick={ handleSwitchToRestore }> {t('messages.aml.forgotYourPassword')} </a>
										</Row>
									}
									{ (isRestore || isCreate) &&
										<a href='#' className="login-link-portal" onClick={ handleSwitchToLogin } style={{ display: 'block', textAlign: 'center', paddingTop: 15 }}>{ t('messages.aml.backToLogin') }</a>
									}
								</div>
								{isLoginView &&
									<div className="login-box portal-register-card">
										<h2 className="title">
											<span>{t('messages.aml.firstTimeUsing')}<br/>{t('messages.aml.theUsersPortal')}</span>
										</h2>
										<Button
											className="login-form-button-portal"
											type="primary"
											htmlType="button"
											onClick={handleSwitchToCreate}
										>
											{t('messages.aml.registerHere')}
										</Button>
									</div>
								}
								</div>
								</Form>
							</Col>
					</Row>
				</div>
			</div>
		</div>
	)
}

const StakeForm = Form.create({ name: 'login_form' })(StakePublic)
export default StakeForm
